// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1Q0Id","signatureButtonsRight":"ModalSign_signatureButtonsRight__3DjGo"};